import React from 'react';
import { withStyles, Grid, Box, Typography } from '@material-ui/core';
import HeadlineText from './HeadlineText';
import DescriptionText from './DescriptionText';

const styles = theme => ({
    iconContainer: {
        borderRadius: 999,
        padding: theme.spacing(5),
        position: 'relative',
    },
    headlineText: {
        fontSize: '2rem',
        fontWeight: 400,
    },
    divider: {
        height: 2,
        width: '100px',
        background: theme.palette.secondary.main,
    },
    descriptionText: {
        [theme.breakpoints.up('md')]: {
            textAlign: 'center'
		},
    },
});

class FeatureBlock extends React.Component {
	render() {
        const { classes, color, icon, headline, description } = this.props;
        
		return (
            <Grid
                container
                alignItems='center'
                justify='center'
                direction='column'
                spacing={3}
            >
                <Grid item>
                    <Box 
                        className={classes.iconContainer}
                        style={{
                            border: `4px solid ${color}`,
                            boxShadow: `0px 0px 30px 0px ${color}`
                        }}
                    >
                        {icon}
                    </Box>
                </Grid>
                <Grid item>
                    <HeadlineText
                        align='center'
                    >
                        {headline}
                    </HeadlineText>
                </Grid>
                <Grid item>
                    <Box
                        className={classes.divider}
                    ></Box>
                </Grid>
                <Grid item>
                    <DescriptionText>
                        {description}
                    </DescriptionText>
                </Grid>
            </Grid>
		);
	}
}

export default withStyles(styles)(FeatureBlock);